import React, { useEffect, useState } from 'react';
import './dashboard.container.sass';
import { useSessionService } from '../../services/session/use-session.service';
import { useDispatch } from 'react-redux';
import { getSession } from '../login/session.slice';
import { MainPage } from '../../components/main-page/main-page';
import { Route, Switch, useHistory } from 'react-router-dom';
import { Config } from '../../config/config';
import { DashboardTeamContainer } from './team/dashboard-team.container';
import { DashboardProfileContainer } from './profile/dashboard-profile.container';
import { DashboardPaymentsContainer } from './payments/dashboard-payments.container';
import { DashboardDiscountContainer } from './discount/dashboard-discount.container';
import { DashboardSettingsContainer } from './settings/dashboard-settings.container';
import { Header } from '../configuration/components/header/header';
import { Footer } from '../landing-page/vendor/components/footer/footer';
import { unwrapResult } from '@reduxjs/toolkit';
import { DashboardChallengesContainer } from './challenges/dashboard-challenges.container';

export const DashboardContainer = () => {

  const {logout, isLoggedIn, addDefaultErrorInterceptors} = useSessionService();
  addDefaultErrorInterceptors();
  const [isSessionFetched, setIsSessionFetched] = useState(false);

  const dispatch = useDispatch();
  const paths = Config.routePaths;
  const history = useHistory();

  useEffect(() => {
    dispatch(getSession({}))
      .then(unwrapResult)
      .then( () => {
        setIsSessionFetched(true);
      });
  }, []);

  const _logout = () => {
    logout();
  };

  if (!isLoggedIn()) {
    _logout();
  }

  return (
    <>
      <MainPage>
        <Header withNavigation={true}/>
        { isSessionFetched ? <div className='vv-dashboard-container'>
          <Switch>
            <Route exact path={paths.main.vendor.dashboard.settings.path} component={DashboardSettingsContainer}/>
            <Route exact path={paths.main.vendor.dashboard.discount.path} component={DashboardDiscountContainer}/>
            <Route exact path={paths.main.vendor.dashboard.payments.path} component={DashboardPaymentsContainer}/>
            <Route exact path={paths.main.vendor.dashboard.challenges.path} component={DashboardChallengesContainer}/>
            <Route exact path={paths.main.vendor.dashboard.profile.path} component={DashboardProfileContainer}/>
            <Route exact path={paths.main.vendor.dashboard.team.path} component={DashboardTeamContainer}/>
          </Switch>
        </div> : null}
      </MainPage>
      <Footer/>
    </>
  );
};
